"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentCreatePayload = void 0;
var SegmentCreatePayload_1 = require("./SegmentCreatePayload");
Object.defineProperty(exports, "SegmentCreatePayload", { enumerable: true, get: function () { return SegmentCreatePayload_1.SegmentCreatePayload; } });
